<template>
  <item-text title="Vārds Uzvārds" :text="branch.contact.name" />
  <template v-if="branch.customer.type.id === 1">
    <item-text title="Tel. nr." :text="branch.contact.phone ? branch.contact.phone : 'Nav norādīts'" />
    <item-text title="E-pasts" :text="branch.contact.email ? branch.contact.email : 'Nav norādīts'" />
  </template>
</template>

<script>
import ItemText from "@/components/Components/ItemText"

export default {
  name: "ShowBranchDetailContact",
  components: {
    ItemText
  },
  props: {
    branch: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style>
</style>